module.exports = __webpack_public_path__ + "static/data-bg.f94d9cf4.png";